import { UseMeasurementFetchParams } from "@/types/measurement/measurement";
import selectBodyMeasurement from "@/utils/select-body-measurement";
import selectMinimalDate from "@/utils/select-minimal-date";
import { useMeasurementSuspenseQuery } from "./use-measurement-suspense-query";
import { useProgramStartDate } from "@/hooks/use-program-start-date";

export const useMeasurementInfo = (type: NonNullable<UseMeasurementFetchParams["query"]>["type"], range: number = 7) => {
  const { data: lastMeasurement } = useMeasurementSuspenseQuery({
    fetchParams: { query: { type, offset: 0, limit: 1, sort: "desc" } },
    queryOptions: {
      select: selectBodyMeasurement,
    },
  });

  const { programStartDate, firstMessageDate } = useProgramStartDate();

  const utcOptions = { timezone: "Etc/UTC", withoutDateDifference: true };

  const minDate = selectMinimalDate(
    programStartDate ?? firstMessageDate,
    lastMeasurement.data[0]?.date,
    range,
    utcOptions
  );
  const canCreate = !minDate || minDate <= new Date();

  return {
    minDate,
    canCreate
  };
}
